export const scoreLogsSpecification = {
  title: '악보로그',
  purpose: '카테고리와 곡 단위의 사용자 플레이 현황을 분석합니다.',
  functions: [
    '기간·카테고리·검색·정렬로 플레이 수를 조회합니다.',
    '상세 화면에서 날짜, 시간, 회원별 실제 플레이 이력을 확인하고 엑셀로 내려받습니다.',
  ],
  connections: [
    '악보관리에 등록된 곡과 카테고리를 기준으로 집계됩니다.',
    '회원 상세의 Raw 로그와 함께 개별 이용 상황을 교차 확인합니다.',
  ],
  app: '사용자 앱에서 악보를 연주할 때마다 곡·난이도·시간 정보가 플레이 로그로 누적됩니다.',
}

export const scoreLogsDataModelGuide = [
  '플레이 키: score_play_id, 연결 키: member_id + score_id + difficulty_code',
  '필수 속성: played_at, 결과 점수, 콤보, 입력 상태, 플레이 모드',
  '목록 집계는 플레이 로그를 기준으로 하며 악보 자체의 공개 상태를 수정하지 않습니다.',
]

export const scoreLogsImplementationGuide = [
  '화면 식별자: scoreLogs. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 카테고리, 곡, 가수, 난이도, 회원, 플레이 시각, 플레이 수, 결과값.',
  '검색·카테고리·기간·정렬 조건으로 플레이 집계 목록을 다시 조회합니다.',
  '상세와 엑셀 다운로드는 동일한 필터 조건과 score_id를 사용합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]
